import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute() {
  const { authHeader } = useAuth();
  return authHeader ? <Outlet /> : <Navigate to="/login" replace />;
}
